import { render } from "./ItemOrderV2.vue?vue&type=template&id=318bfd9b&scoped=true"
import script from "./ItemOrderV2.vue?vue&type=script&lang=js"
export * from "./ItemOrderV2.vue?vue&type=script&lang=js"

import "./ItemOrderV2.vue?vue&type=style&index=0&id=318bfd9b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318bfd9b"]])

export default __exports__